import { FC } from 'react';
import { Grid, GridItem, GridItemProps } from '@chakra-ui/react';

import webView from 'common/webView';
import ProgressBar from 'components/_core/ProgressBar';
import SunshineIcon from 'components/_core/SunshineIcon';
import BackButton from 'components/BackButton';
import { MicroEstimationStepProgress } from 'features/Accounting/pages/Estimation/flows/microEstimation/machine';
import zIndices from 'theme/foundations/zIndex';

import { HEADER_GRID_AREA } from '../../constants';

interface HeaderProps extends GridItemProps {
  onBack: () => void;
  stepProgress: MicroEstimationStepProgress;
  onOpenDrawer?: () => void;
}

const Header: FC<HeaderProps> = ({
  onBack,
  onOpenDrawer,
  stepProgress,
  ...gridItemProps
}) => {
  const { isInWebView } = webView;

  if (isInWebView) {
    return (
      <GridItem
        backgroundColor="white"
        padding="space-16"
        position="sticky"
        top={0}
        zIndex={zIndices.sticky}
        {...gridItemProps}
        gridArea={HEADER_GRID_AREA}
      >
        <Grid
          alignItems="center"
          gridTemplateColumns="10% 50% 10%"
          justifyContent="space-between"
        >
          <SunshineIcon
            color="primary"
            name="arrow-left"
            onClick={onBack}
            size="icon-24"
          />

          <ProgressBar ratio={stepProgress.current / stepProgress.total} />

          {onOpenDrawer ? (
            <SunshineIcon
              color="primary"
              justifySelf="flex-end"
              name="information"
              onClick={onOpenDrawer}
              size="icon-24"
            />
          ) : null}
        </Grid>
      </GridItem>
    );
  }

  return (
    <GridItem
      paddingBottom="space-16"
      paddingTop="space-40"
      {...gridItemProps}
      gridArea={HEADER_GRID_AREA}
    >
      <BackButton onClick={onBack} />
    </GridItem>
  );
};

export default Header;
